import React, { useState } from 'react';
import { ChevronDown, Fuel } from 'lucide-react';
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from '../ui/collapsible';

export const OtherPaymentOptions = ({ children }) => {
  const [open, setOpen] = useState(false);
  return (
    <div className="space-y-4">
      <div className="bg-emerald-500/10 border border-emerald-500/30 rounded-xl p-4 flex items-start gap-3" data-testid="beth-gas-notice">
        <Fuel className="w-5 h-5 text-emerald-400 shrink-0 mt-0.5" />
        <p className="text-sm text-slate-200">
          <strong className="text-white">BETH Gas covers your network fees.</strong> Every check action costs a single 1% BETH gas fee, paid by card.
          The BETH Treasury Reserve pays the blockchain fees on Base for you, so you don't need your own ETH or a crypto wallet.
        </p>
      </div>
      <Collapsible open={open} onOpenChange={setOpen}>
        <CollapsibleTrigger data-testid="other-payment-options-toggle"
          className="w-full flex items-center justify-between px-4 py-3 rounded-xl bg-slate-800 border border-slate-700 text-sm text-slate-300 hover:text-white">
          Other options: MetaMask wallet, buy ETH (MoonPay / Transak)
          <ChevronDown className={`w-4 h-4 transition-transform ${open ? 'rotate-180' : ''}`} />
        </CollapsibleTrigger>
        <CollapsibleContent className="space-y-6 pt-4" data-testid="other-payment-options-content">{children}</CollapsibleContent>
      </Collapsible>
    </div>
  );
};

export default OtherPaymentOptions;
